// src/appRWAPromo/stream/analysisProfiles.js

const KNOWN = new Set([
  "politics",
  "sports",
  "finance",
  "crypto",
  "geopolitics",
  "tech",
  "world",
  "economy",
]);

function normCategory(categoryRaw) {
  return String(categoryRaw || "").trim().toLowerCase();
}

export function getAnalysisProfile(categoryRaw) {
  const c = normCategory(categoryRaw);

  // неизвестное/пустое — тоже уводим в generic
  const category = KNOWN.has(c) ? c : "unknown";

  if (category === "crypto") {
    return {
      engine: "crypto",
      callableType: "token_signal",
      needsSymbol: true,
      defaultTf: "1h",
      allowedTypes: ["token_signal", "market_forecast", "top_forecasts", "chart_levels"],
    };
  }

  // пока все остальные категории — заглушка (без запуска crypto)
  return {
    engine: "generic",
    callableType: "generic_brief",
    needsSymbol: false,
    defaultTf: "1d",
    allowedTypes: ["generic_brief"],
  };
}
